import React from 'react';
import { Row, Col } from 'reactstrap';

import './header.scss';

function Header() {
  return (
    <Row>
      <Col>
        <div className="header-wrapper">
            &nbsp;
          <div className="title-wrapper">
            <h1>An Open Letter to the USC Community</h1>
            <div className="intro">
              In support of the people of Israel
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default Header;
